import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserState, SubscriptionDetails } from '../../types';

const initialState: UserState = {
  email: '',
  firstName: '',
  lastName: '',
  isLoggedIn: false,
  subscriptionDetails: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setEmail: (state, action: PayloadAction<string>) => {
      state.email = action.payload;
    },
    setIsLoggedIn: (state, action: PayloadAction<boolean>) => {
      state.isLoggedIn = action.payload;
    },
    setSubscriptionDetails: (state, action: PayloadAction<SubscriptionDetails | null>) => {
      state.subscriptionDetails = action.payload;
    },
    setUser: (
      state,
      action: PayloadAction<{ 
        email: string; 
        firstName?: string;
        lastName?: string;
        subscriptionDetails?: SubscriptionDetails | null;
      }>
    ) => {
      state.email = action.payload.email;
      state.firstName = action.payload.firstName ?? '';
      state.lastName = action.payload.lastName ?? '';
      state.isLoggedIn = true;
      state.subscriptionDetails = action.payload.subscriptionDetails ?? null;
    },
    setUserName: (
      state,
      action: PayloadAction<{ firstName: string; lastName: string }>
    ) => {
      state.firstName = action.payload.firstName;
      state.lastName = action.payload.lastName;
    },
    logout: (state) => {
      state.email = '';
      state.firstName = '';
      state.lastName = '';
      state.isLoggedIn = false;
      state.subscriptionDetails = null;
    },
  },
});

export const { setEmail, setIsLoggedIn, setSubscriptionDetails, setUser, setUserName, logout } =
  userSlice.actions;
export default userSlice.reducer;

